/** Adaptive DocuSign signature sync — fast right after opening the iframe, then slower. */

export const DOCUSIGN_SIGNATURE_POLL_FAST_MS = 12_000
export const DOCUSIGN_SIGNATURE_POLL_SLOW_MS = 45_000
/** Aggressive polling window after the iframe is shown (stays under DocuSign hourly quota with server cache). */
export const DOCUSIGN_SIGNATURE_FAST_POLL_WINDOW_MS = 5 * 60_000

/**
 * Repeatedly calls `sync` while the signing iframe is open.
 * Polls every 12s for the first 5 minutes, then every 45s. Skips calls when the tab is hidden.
 */
export function startDocusignSignaturePolling(sync: () => void | Promise<void>): () => void {
  const startedAt = Date.now()
  let timeoutId: ReturnType<typeof setTimeout> | undefined
  let stopped = false

  const stop = () => {
    stopped = true
    if (timeoutId !== undefined) clearTimeout(timeoutId)
  }

  const scheduleNext = () => {
    if (stopped) return
    const elapsed = Date.now() - startedAt
    const delay =
      elapsed < DOCUSIGN_SIGNATURE_FAST_POLL_WINDOW_MS
        ? DOCUSIGN_SIGNATURE_POLL_FAST_MS
        : DOCUSIGN_SIGNATURE_POLL_SLOW_MS
    timeoutId = setTimeout(run, delay)
  }

  const run = () => {
    if (stopped) return
    if (!document.hidden) {
      Promise.resolve(sync()).finally(scheduleNext)
    } else {
      scheduleNext()
    }
  }

  if (!document.hidden) {
    Promise.resolve(sync()).finally(scheduleNext)
  } else {
    scheduleNext()
  }

  return stop
}
